import { ITradeSettingsStore } from "@/store/tradeSettingsStore";
import { IToggleCounterpartiesButton } from "../../helper/tradeSettingsHelper/tradeSettingsInterfaces";
import { setTradeSettingsSelectedCounterparties } from "@/store/tradeSettingsStoreACTIONS";

function areStringArraysEqual(arr1: string[], arr2: string[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  // 2. Iterate and compare each element
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      // Use strict equality for string comparison
      return false;
    }
  }
  // 3. If all elements match and lengths are equal, the arrays are equal
  return true;
}

export function compareArraysOfCounterparties(
  validCounterpartiesList: IToggleCounterpartiesButton[],
  counterpartiesList: IToggleCounterpartiesButton[],
): boolean {
  const cpCodesFromEndpoint = validCounterpartiesList.reduce(
    (acc: string[], current): string[] => {
      acc.push(current.code);
      return acc;
    },
    [],
  );
  const cpCodesFromTradeSettings = counterpartiesList.reduce(
    (acc: string[], current): string[] => {
      acc.push(current.code);
      return acc;
    },
    [],
  );
  const sortedA: string[] = [...cpCodesFromEndpoint]
    .map((s) => s.toLowerCase())
    .sort();
  const sortedB: string[] = [...cpCodesFromTradeSettings]
    .map((s) => s.toLowerCase())
    .sort();

  return areStringArraysEqual(sortedA, sortedB);
}

export function updateListOfSettingsCPsBasedOnEndpoint(
  thisTradeSettings: ITradeSettingsStore,
  validCounterpartiesList: IToggleCounterpartiesButton[],
  esid: string,
) {
  const tempCPList = validCounterpartiesList.map((newCPs) => {
    const cpInSettings = thisTradeSettings.counterpartiesList.find(
      (cp) => cp.code == newCPs.code,
    );
    if (cpInSettings) {
      return { ...cpInSettings };
    } else {
      return { ...newCPs };
    }
  });

  //   Send New CP list to the trade settings - This will have filtered out CPs no longer there and added new ones.
  if (tempCPList) {
    setTradeSettingsSelectedCounterparties({
      esid: esid,
      newCounterpartyList: tempCPList,
    });
  }
}
